import { customerSettingsFragment } from 'apollo/fragments';
import { dentistFragment, technicianFragment, userListFragment } from 'apollo/fragments/user';
import { gql } from 'graphql.macro';

export const getUserByEmailTemplate = gql`
    query userByEmail($email: String!) {
        userByEmail(email: $email) {
            _id
            organization {
                _id
                name
                isWhiteLabeled
                customerSettings {
                    ...customerSettingsFields
                }
            }
            email
            fullName
            role
            active
            isShared
            type
            whiteLabelAccess
            enableUserSync
        }
    }
    ${customerSettingsFragment}
`;

export const getDentistsForUserListTemplate = gql`
    query dentists($clinicId: MongoDbObjectId, $filters: UsersFilters, $limit: Int!, $offset: Int!) {
        dentists(clinicId: $clinicId, filters: $filters, limit: $limit, offset: $offset) {
            ...dentistFields
        }
    }
    ${dentistFragment}
`;

export const getUserListTemplate = gql`
    query users($orgId: MongoDbObjectId, $filters: UsersAdminFilters, $limit: Int!, $offset: Int!) {
        users(orgId: $orgId, filters: $filters, limit: $limit, offset: $offset) {
            ...userListFields
        }
    }
    ${userListFragment}
`;

export const getTechniciansForAdminUserListTemplate = gql`
    query technicians($labId: MongoDbObjectId, $filters: UsersFilters, $limit: Int!, $offset: Int!) {
        technicians(labId: $labId, filters: $filters, limit: $limit, offset: $offset) {
            ...technicianFields
        }
    }
    ${technicianFragment}
`;

export const getRolesTemplate = gql`
    query roles($type: String) {
        roles(type: $type) {
            _id
            role
        }
    }
`;

export const getChildClinicsWithParentTemplate = gql`
    query childClinicsWithParent($parentClinicId: MongoDbObjectId, $showOnlyDeliveryLocations: Boolean) {
        childClinicsWithParent(parentClinicId: $parentClinicId, showOnlyDeliveryLocations: $showOnlyDeliveryLocations) {
            _id
            type
            name
            isMain
            parentClinicId
            contact {
                communication {
                    email
                }
            }
        }
    }
`;

export const getLabsTemplate = gql`
    query labs($isTransportEnable: Boolean) {
        labs(isTransportEnable: $isTransportEnable) {
            _id
            name
        }
    }
`;

export const getParentClinicsTemplate = gql`
    query parentClinics($limit: Int, $offset: Int) {
        parentClinics(limit: $limit, offset: $offset) {
            _id
            name
        }
    }
`;

export const getImpersonateUserTokenTemplate = gql`
    query impersonateUser($userId: MongoDbObjectId!, $organizationId: MongoDbObjectId!) {
        impersonateUser(userId: $userId, organizationId: $organizationId) {
            token
            expiresAt
        }
    }
`;
